
export const organizationData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Millance",
  "url": "https://millance.com",
  "logo": "https://millance.com/logo.png",
  "sameAs": [
    "https://www.facebook.com/millancefx",
    "https://www.instagram.com/millancefx",
    "https://www.linkedin.com/company/millancefx"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+971 50 228 4750",
    "contactType": "customer service",
    "areaServed": "Worldwide",
    "availableLanguage": ["English"]
  }
};

export const jsonLdByPath = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Trade Smarter with Millance – Your Forex Partner",
    "description": "Millance offers secure, AI-powered forex trading solutions...",
    "url": "https://millance.com/",
    "image": "https://millance.com/images/home/homegif.gif"
  },

  {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "Learn About Millance – Vision, Mission & Values",
    "description": "Discover Millance's mission, team, and values driving innovation in forex trading.",
    "url": "http://millance.com/about-us",
    "image": "https://millance.com/images/aboutus/ourfu.png"
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Why Choose Millance – Trusted Forex Trading Partner",
    "description": "Find out what makes Millance the preferred forex broker. Enjoy transparency, security, low spreads, and cutting-edge tools for better trading.",
    "url": "https://millance.com/why-choose-millance",
    "image": "https://millance.com/images/whychoose/whychoosebanners.png"
  },

  {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact Millance – Reach Our Support & Sales Team",
    "description": "Need help with your trading journey? Contact Millance support for inquiries, partnerships, or assistance via email, phone, or contact form.",
    "url": "https://millance.com/contact-us",
    "image": "https://millance.com/images/contact/support6.png"
  },

  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How do I create an account with Millance?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can create an account by clicking 'Sign Up' on our homepage and following the verification steps."
        }
      },
      {
        "@type": "Question",
        "name": "Is Millance regulated?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, Millance operates under strict regulatory and compliance standards. Visit the legal documents page for full info."
        }
      }
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "FinancialProduct",
    "name": "Millance Forex Trading Account",
    "description": "Choose from various Millance account types with low spreads and flexible leverage.",
    "url": "https://millance.com/forex-trading-account-types",
    "provider": {
      "@type": "Organization",
      "name": "Millance"
    }
  },

  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Millance Forex Pip Calculator",
    "operatingSystem": "All",
    "applicationCategory": "FinanceApplication",
    "description": "Use the Millance pip calculator to measure trade profits and risk.",
    "url": "https://millance.com/pip-calculator"
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What are the different account types offered by Millance?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Millance offers Standard, ECN, and Pro accounts to suit various trading styles and experience levels."
        }
      },
      {
        "@type": "Question",
        "name": "How can I fund my Millance trading account?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can fund your account through multiple options including bank transfer, credit/debit card, and e-wallets."
        }
      },
      {
        "@type": "Question",
        "name": "What tools are available for traders on Millance?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Millance provides MetaTrader 5, pip calculators, risk management tools, and market analysis insights."
        }
      }
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "FinancialProduct",
    "name": "Millance Forex Trading Account Types",
    "description": "Choose from various Millance account types for every trader. Compare spreads, leverage, minimum deposits, and features to suit your needs.",
    "image": "https://millance.com/images/accountype/accountbanner1.png",
    "url": "https://millance.com/forex-trading-account-types",
    "provider": {
      "@type": "Organization",
      "name": "Millance",
      "url": "https://millance.com"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Live Forex Economic Calendar – Market Events Guide",
    "description": "Track key economic events and news affecting global markets. Millance's real-time calendar helps traders make informed decisions daily.",
    "url": "https://millance.com/economic-calendar",
    "image": "https://millance.com/images/calender/Economic_Calendar.gif"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Forex Currency Trading with Millance – Start Today",
    "description": "Trade major, minor, and exotic currency pairs with Millance. Benefit from tight spreads, fast execution, and advanced trading features.",
    "url": "https://millance.com/forex-currency-trading",
    "image": "https://millance.com/images/main/currency1.png"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Join Millance’s Introducing Broker Program Today",
    "description": "Earn commissions by referring clients through Millance’s IB program. Enjoy marketing support, real-time tracking, and timely payouts.",
    "url": "https://millance.com/introducing-broker-program",
    "image": "https://millance.com/images/introbroker/intro.png",
    "keywords": [
      "Introducing Broker",
      "Millance IB program",
      "forex referral",
      "affiliate trading program",
      "commission earnings"
    ]
  },


  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Millance Legal Documents – Terms and Policies Guide",
    "description": "Read Millance’s legal documents including trading terms, privacy policy, risk disclosure, and more to trade with confidence and compliance.",
    "url": "https://millance.com/legal-documents",
    "image": "https://millance.com/images/legal/document.png"
  },
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "MetaTrader 5 by Millance",
    "operatingSystem": "Windows, macOS, Web, Android, iOS",
    "applicationCategory": "FinanceApplication",
    "description": "Use the advanced MetaTrader 5 platform at Millance for lightning-fast forex trading, in-depth analytics, and automated strategy integration.",
    "image": "https://millance.com/images/mt5/window.png",
    "url": "https://millance.com/metatrader-5",
    "publisher": {
      "@type": "Organization",
      "name": "Millance",
      "url": "https://millance.com"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Forex Account Funding Options at Millance Today",
    "description": "Deposit funds easily and securely using various payment methods. Millance supports instant funding for fast and smooth trading experience.",
    "url": "https://millance.com/forex-account-funding",
    "image": "https://millance.com/images/main/despoitwithdraw.png"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Automated Forex Algo Trading – Millance Platform",
    "description": "Automate your trading strategies with Millance's algorithmic trading tools. Enhance speed, precision, and scalability in forex markets.",
    "url": "https://millance.com/forex-algo-trading",
    "image": "https://millance.com/images/algoimg/algo-basics.png"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Negative Balance Protection with Millance Forex",
    "description": "Stay protected from market volatility. Millance offers negative balance protection so your trading losses never exceed your investment.",
    "url": "https://millance.com/negative-balance-protection",
    "image": "https://millance.com/images/negativeb/negativebb.gif"
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Invest in PAMM Accounts with Millance Platform",
    "description": "Join Millance PAMM accounts to invest in expert traders. Transparent profit sharing and performance tracking for smart investments.",
    "url": "https://millance.com/pamm-account",
    "image": "https://millance.com/images/pamm/pamm2.png"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Effective Forex Risk Management Tools at Millance",
    "description": "Explore Millance's forex risk management strategies and tools to minimize losses, optimize trades, and protect your capital efficiently.",
    "url": "https://millance.com/forex-risk-management",
    "image": "https://millance.com/images/risk/riskbanner.png"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Daily Forex Market Analysis – Millance Insights",
    "description": "Get expert forex market analysis with trends, news, and forecasts. Make informed trading decisions with Millance’s daily insights.",
    "url": "https://millance.com/forex-market-analysis",
    "image": "https://millance.com/images/marketanaly/analychart3.jpg"
  },
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Millance Forex Pip Calculator",
    "description": "Use the Millance pip calculator to measure trade profits, losses, and risk. Plan better with accurate pip value calculations instantly.",
    "url": "https://millance.com/pip-calculator",
    "applicationCategory": "FinanceApplication",
    "operatingSystem": "All",
    "image": "https://millance.com/images/pipcalc/Sell.gif"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Join Millance Forex Affiliate Program – Earn More",
    "description": "Refer traders and earn commissions with the Millance affiliate program. Get promo tools, tracking, and timely payouts every month.",
    "url": "https://millance.com/forex-affiliate-program",
    "image": "https://millance.com/images/main/Partners.png"
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Millance Forex Trading Assets – Instruments List",
    "description": "Explore a broad range of forex trading instruments with Millance. Trade currency pairs, metals, indices, and more with tight spreads.",
    "url": "https://millance.com/forex-trading-assets",
    "image": "https://millance.com/images/main/commodities2.png",
    "keywords": [
      "forex assets",
      "trade instruments",
      "Millance trading pairs",
      "currency trading",
      "metals indices forex"
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Open Forex Live Account at Millance Instantly",
    "description": "Start trading live forex markets with Millance. Open your live account with easy KYC and access real-time spreads and trade execution.",
    "url": "https://millance.com/forex-live-account",
    "image": "https://millance.com/logo.png"
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Forex Demo Account by Millance – Practice Free",
    "description": "Practice risk-free with a Millance demo account. Trade live markets using virtual funds and sharpen your forex trading strategies.",
    "url": "https://millance.com/forex-demo-account",
    "image": "https://millance.com/images/main/map1.png"
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Segregated Forex Accounts – Trade with Millance",
    "description": "Millance uses segregated client accounts to ensure your trading funds are protected and kept separate from company operations.",
    "url": "https://millance.com/forex-brokers-segregated-accounts",
    "image": "https://millance.com/images/main/lasts.png"
  },


  {
    "@context": "https://schema.org",
    "@type": "EducationalOccupationalProgram",
    "name": "Learn Forex Trading Basics – Millance Education",
    "description": "New to forex? Start learning with Millance basics guide. Understand pairs, charts, leverage, and how to start your trading journey.",
    "provider": {
      "@type": "Organization",
      "name": "Millance"
    },
    "url": "https://millance.com/learn-forex-trading-basics",
    "image": "https://millance.com/images/main/forex-trade.png"
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Millance Forex Trading Fees – Cost Structure Guide",
    "description": "Understand Millance’s transparent trading fees including spreads, swaps, and commissions. Plan your strategy with fee clarity.",
    "url": "https://millance.com/learn-forex-trading-fees"
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Trade Global Indices Online – Millance Platform",
    "description": "Diversify your portfolio by trading global indices with Millance. Access major markets like NASDAQ, DAX, FTSE with fast execution.",
    "url": "https://millance.com/indices-trading",
    "image": "https://millance.com/images/main/indices3.png"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Online Share Trading – Trade Stocks with Millance",
    "description": "Trade top global company stocks with Millance. Get access to real-time pricing, low fees, and powerful trading platforms.",
    "url": "https://millance.com/trading-shares",
    "image": "https://millance.com/images/main/shares1.png"
  },
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Forex Lot Size Calculator – Plan Trades at Millance",
    "operatingSystem": "All",
    "applicationCategory": "FinanceApplication",
    "description": "Use our lot size calculator to optimize trade volumes and manage risk efficiently. Essential for planning successful forex trades.",
    "url": "https://millance.com/forex-lot-size-calculator",
    "image": "https://millance.com/images/loader-design.gif"
  },

  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Forex Profit Calculator by Millance – Estimate Now",
    "operatingSystem": "All",
    "applicationCategory": "FinanceApplication",
    "description": "Estimate potential profits or losses with Millance’s profit calculator. Enter trade size, currency pair, and price to simulate returns.",
    "url": "https://millance.com/forex-profit-calculator",
    "image": "https://millance.com/images/loader-design.gif"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Millance Cart – Review Selected Services & Tools",
    "description": "View and manage your selected Millance services or subscriptions in the cart before checkout. Adjust preferences anytime.",
    "url": "https://millance.com/cart",
    "image": "https://millance.com/images/webdevelopment.png"
  }
  ,
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Secure Millance Checkout Form – Complete Orders",
    "description": "Finalize your order securely with Millance’s encrypted checkout form. Fast processing for service subscriptions or add-ons.",
    "url": "https://millance.com/checkout-form",
    "image": "https://millance.com/images/webdevelopment.png"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Millance Return & Refund Policy – Read Full Terms",
    "description": "Read our clear return and refund policy to understand your rights and conditions. Millance ensures fair service to every user.",
    "url": "https://millance.com/return-and-refund-policy",
    "image": "https://millance.com/images/legal/document.png"
  },
  {
    "@context": "https://schema.org",
    "@type": "TermsOfService",
    "name": "Millance Terms and Conditions | User Agreement & Legal Policy",
    "description": "Review Millance’s Terms and Conditions to understand user rights, service usage rules, legal disclaimers, and platform obligations before using our services.",
    "url": "https://millance.com/terms-condition",
    "image": "https://millance.com/images/aboutus/ourfu.png"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Millance Login | Sign In to Your Forex Trading Account",
    "description": "Access your Millance forex trading account securely. Sign in to manage trades, monitor performance, and explore smart trading features.",
    "url": "https://millance.com/sign-in",
    "inLanguage": "en",
    "image": "https://millance.com/images/aboutus/ourfu.png"
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Best Forex Copy Trading Platform | Copy Top Traders on Millance",
    "description": "Join the best forex copy trading platform and earn like a pro! Millance lets you copy top traders, automate forex strategies with zero trading experience.",
    "url": "https://millance.com/copy-trade",
    "image": "https://millance.com/images/aboutus/ourfu.png"
  }
];
